import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const baseStyle = {
  width: "100%",
  padding: "0.75rem 2.5rem 0.75rem 1rem",
  fontSize: "0.95rem",
  border: "1.5px solid #e2e8f0",
  borderRadius: "0.625rem",
  outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
  background: "#fff",
  color: "#1e293b",
  boxSizing: "border-box",
};

export function PasswordField({
  value,
  onChange,
  name = "password",
  placeholder = "Tu contraseña",
  autoComplete = "current-password",
  onKeyDown,
  disabled = false,
}) {
  const [reveal, setReveal] = useState(false);

  const handleFocus = (e) => {
    e.target.style.borderColor = "#0353a4";
    e.target.style.boxShadow = "0 0 0 3px rgba(3,83,164,0.1)";
  };
  const handleBlur = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type={reveal ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete={autoComplete}
        name={name}
        disabled={disabled}
        style={baseStyle}
      />
      <button
        type="button"
        onClick={() => setReveal((r) => !r)}
        aria-label={reveal ? "Ocultar contraseña" : "Mostrar contraseña"}
        tabIndex={-1}
        style={{
          position: "absolute",
          right: "0.5rem",
          top: "50%",
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          padding: "0.4rem",
          cursor: "pointer",
          color: "#64748b",
          display: "flex",
          alignItems: "center",
        }}
      >
        {reveal ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
